import { getUserLocationByCoord } from './hooks'

export default function UserLocationTitle({ coords, title }) {
  const locationInfo = getUserLocationByCoord(coords, title)
  return locationInfo.title
}
